export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/48c3d350a874654b9919fc00f7ab5f35.png";